import { Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { AgreementEsignatureToggle } from 'modules/performance_process/components/review/settings/AgreementEsignatureToggle'
import { SettingsToggle } from 'modules/performance_process/components/review/settings/SettingsToggle'
import { useNewPerformanceModuleContext } from 'modules/performance_process/pages/ReviewsRootPage'

export type TypeSettingsFeatures = {
  agreementsConfiguration: boolean
  agreementsEsignatureConfiguration: boolean
  competenciesAssessmentsConfiguration: boolean
  employeePotentialScoreConfiguration: boolean
  republishEvaluationsConfiguration: boolean
}

type Props = {
  features: TypeSettingsFeatures
  disabled: boolean | TypeSettingsFeatures
  onFeatureToggled: (feature: keyof TypeSettingsFeatures, enabled: boolean) => void
}

export const SettingsFeatures: React.FC<Props> = ({ features, disabled, onFeatureToggled }) => {
  const { isAgreementDocumentEnabled } = useNewPerformanceModuleContext()

  const isDisabled = (feature: keyof TypeSettingsFeatures) => {
    if (typeof disabled === 'boolean') {
      return disabled
    }
    return disabled[feature]
  }

  return (
    <Box gap="s16">
      <SettingsToggle
        title={i18n.t('performance_process.agreements.settings.title')}
        description={i18n.t('performance_process.agreements.settings.description')}
        onChange={(value) => onFeatureToggled('agreementsConfiguration', value)}
        checkboxAriaLabel={i18n.t('performance_process.agreements.settings.toggle_checkbox_label')}
        value={features.agreementsConfiguration}
        disabled={isDisabled('agreementsConfiguration')}
        CollapsableContent={
          isAgreementDocumentEnabled && (
            <AgreementEsignatureToggle
              value={features.agreementsEsignatureConfiguration}
              disabled={isDisabled('agreementsEsignatureConfiguration')}
              onChange={(value) => onFeatureToggled('agreementsEsignatureConfiguration', value)}
            />
          )
        }
      />
      <SettingsToggle
        title={i18n.t('performance_process.employee_potential_score.settings.title')}
        description={i18n.t('performance_process.employee_potential_score.settings.description')}
        onChange={(value) => onFeatureToggled('employeePotentialScoreConfiguration', value)}
        value={features.employeePotentialScoreConfiguration}
        checkboxAriaLabel={i18n.t(
          'performance_process.employee_potential_score.settings.toggle_checkbox_label'
        )}
        disabled={isDisabled('employeePotentialScoreConfiguration')}
      />
      <SettingsToggle
        title={i18n.t('performance_process.competency_assessment.settings.title')}
        description={i18n.t('performance_process.competency_assessment.settings.description')}
        onChange={(value) => onFeatureToggled('competenciesAssessmentsConfiguration', value)}
        checkboxAriaLabel={i18n.t(
          'performance_process.competency_assessment.settings.toggle_checkbox_label'
        )}
        value={features.competenciesAssessmentsConfiguration}
        disabled={isDisabled('competenciesAssessmentsConfiguration')}
      />
      <SettingsToggle
        title={i18n.t('performance_process.republish_evaluations.settings.title')}
        description={i18n.t('performance_process.republish_evaluations.settings.description')}
        onChange={(value) => onFeatureToggled('republishEvaluationsConfiguration', value)}
        checkboxAriaLabel={i18n.t(
          'performance_process.republish_evaluations.settings.toggle_checkbox_label'
        )}
        value={features.republishEvaluationsConfiguration}
        disabled={isDisabled('republishEvaluationsConfiguration')}
      />
    </Box>
  )
}
